export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const device = useDevice()
 


  const isProductionRef = computed(() => Boolean(process.server
    ? config.isProdMode
    : config.public.isProdMode))

  const showMobileAdsRef = computed(
    () => isProductionRef.value && device.isMobile && !device.isTablet
  )

  const showDesktopAdsRef = computed(
    () => isProductionRef.value && device.isDesktop
  )

  const isDesktop = computed(
    () => device.isDesktop
  )


  const screen = {
    // 👇 getters: template dobija boolean, ne Ref objekat
    get isProduction() {
      return isProductionRef.value
    },
    get showMobileAds() {
      return showMobileAdsRef.value
    },
    get showDesktopAds() {
      return showDesktopAdsRef.value
    },
    get isDesktop() {
      return isDesktop.value
    },
    device,
  }

  return {
    provide: { screen },
  }
})
